export const translations = {
  cs: {
    // Common
    products: 'produkty',
    product: 'produkt',
    brands: 'značky',
    brand: 'značka',
    categories: 'kategorie',
    category: 'kategorie',
    vendor: 'prodejce',
    vendors: 'prodejci',
    search: 'Vyhledat',
    loading: 'Načítání...',
    error: 'Chyba',

    // Header
    searchPlaceholder: 'Vyhledat produkty, značky, kategorie...',

    // Home Page
    heroTitle: 'Porovnejte ceny, najděte nejlepší nabídky',
    heroSubtitle: 'Procházejte tisíce produktů od důvěryhodných prodejců. Získejte zaručenou nejlepší cenu.',
    popularCategories: 'Oblíbené kategorie',
    allProducts: 'Všechny produkty',
    productsIn: 'Produkty v',
    showing: 'Zobrazeno',
    loadMoreProducts: 'Načíst další produkty',

    // Product Card
    comparePrices: 'Porovnat ceny',

    // Recently Viewed
    recentlyViewed: 'Nedávno zobrazené',
    clearHistory: 'Vymazat historii',
    clear: 'Vymazat',

    // Product Page
    backToProducts: 'Zpět na produkty',
    priceRange: 'Cenové rozpětí',
    variants: 'Varianty',
    totalOffers: 'Celkový počet nabídek',
    specifications: 'Specifikace',
    availableOffers: 'Dostupné nabídky',
    updated: 'Aktualizováno',
    viewOffer: 'Zobrazit nabídku',
    errorLoadingProduct: 'Chyba při načítání produktu. Zkuste to prosím znovu.',
    returnToHome: 'Zpět na domovskou stránku',
    noOffers: 'Pro tento produkt nejsou k dispozici žádné nabídky.',
    relatedProducts: 'Související produkty',
    productVariants: 'Varianty produktu',
    quickView: 'Rychlý náhled',
    inStock: 'Skladem',
    outOfStock: 'Vyprodáno',
    unknown: 'Neznámý',
    color: 'Barva',
    size: 'Velikost',
    memory: 'Paměť',
    storage: 'Úložiště',
    material: 'Materiál',
    nameZA: 'Název (Z-A)',
    mostPopular: 'Nejpopulárnější',
    mostVendors: 'Nejvíce prodejců',

    // Share
    share: 'Sdílet',
    copyLink: 'Kopírovat odkaz',
    linkCopied: 'Odkaz zkopírován',
    // Cookie Consent
    cookieConsent: 'Souhlas s cookies',
    acceptAll: 'Přijmout vše',
    decline: 'Odmítnout',

    // Filters
    filters: 'Filtry',
    activeFilters: 'Aktivní filtry',
    priceRangeLabel: 'Cenové rozpětí',
    sortBy: 'Seřadit podle',
    nameAZ: 'Název (A-Z)',
    priceLowToHigh: 'Cena: od nejnižší',
    priceHighToLow: 'Cena: od nejvyšší',
    newestFirst: 'Nejnovější',
    clearFilters: 'Vymazat filtry',
    allCategories: 'Všechny kategorie',
    allBrands: 'Všechny značky',
    minPrice: 'Min. cena',
    maxPrice: 'Max. cena',

    // Search Page
    searchResultsFor: 'Výsledky vyhledávání pro:',

    // Brands Page
    browseByBrand: 'Procházet podle značky',
    allBrands: 'Všechny značky',
    searchBrands: 'Vyhledat značky...',
    found: 'nalezeno',

    // Categories Page
    browseByCategory: 'Procházet podle kategorie',
    allCategories: 'Všechny kategorie',
    searchCategories: 'Vyhledat kategorie...',
    noMatchingCategories: 'Nebyly nalezeny žádné kategorie odpovídající',
    noMatchingBrands: 'Nebyly nalezeny žádné značky odpovídající',

    // Product Grid
    errorLoadingProducts: 'Chyba při načítání produktů. Zkuste to prosím znovu.',

    // Empty States
    noSearchResults: 'Nenalezeny žádné výsledky',
    noSearchResultsMessage: 'Nenašli jsme žádné produkty odpovídající vašemu vyhledávání',
    noFilteredResults: 'Žádné produkty nevyhovují filtrům',
    noFilteredResultsMessage: 'Zkuste upravit nebo vymazat některé filtry pro zobrazení více výsledků.',
    noCategoryProducts: 'V této kategorii nejsou žádné produkty',
    noCategoryProductsMessage: 'Momentálně nemáme produkty v této kategorii.',
    noProductsAvailable: 'Žádné produkty k dispozici',
    noProductsAvailableMessage: 'Momentálně nejsou k dispozici žádné produkty.',
    suggestions: 'Doporučení',
    searchSuggestion1: 'Zkuste jiná klíčová slova',
    searchSuggestion2: 'Zkuste obecnější výrazy',
    searchSuggestion3: 'Zkontrolujte pravopis',
    categorySuggestion1: 'Procházejte další kategorie',
    categorySuggestion2: 'Vyzkoušejte vyhledávání',
    filterSuggestion1: 'Vymažte některé filtry',
    filterSuggestion2: 'Rozšiřte cenové rozpětí',
    browseAllCategories: 'Procházet všechny kategorie',
    backToHome: 'Zpět na domovskou stránku',

    // Footer
    footerTagline: 'Vaše prémiové multi-vendor tržiště. Porovnejte ceny a najděte nejlepší nabídky od důvěryhodných prodejců.',
    allRightsReserved: 'Všechna práva vyhrazena',

    // Legal Pages
    privacyPolicy: 'Ochrana osobních údajů',
    termsConditions: 'Obchodní podmínky',
    cookiePolicy: 'Zásady používání cookies',
    imprint: 'Právní upozornění',
    returnPolicy: 'Reklamace a vrácení zboží',
    shippingPolicy: 'Doprava a doručení',
    contact: 'Kontakt',
    aboutUs: 'O nás',
    legal: 'Právní informace',
    customerService: 'Zákaznický servis',
    lastUpdated: 'Poslední aktualizace',

    // 404 Page
    notFoundTitle: 'Stránka nebyla nalezena',
    notFoundMessage: 'Stránka, kterou hledáte, neexistuje nebo byla přesunuta.',
    searchProducts: 'Hledat produkty',

    // Price History
    priceHistory: 'Vývoj ceny',
    lowestInDays: 'Nejníže za {days} dní',
    daysRange: '{days} dní',
    priceTrendDown: 'Cena od začátku období klesla o {pct} %',
    priceTrendUp: 'Cena od začátku období vzrostla o {pct} %',
    priceTrendStable: 'Cena je stabilní',

    // Compare
    compare: 'Porovnat',
    compareProducts: 'Porovnat produkty',
    addToCompare: 'Přidat k porovnání',
    removeFromCompare: 'Odebrat z porovnání',
    compareFull: 'Porovnání je plné (max 4)',
    selectProductsToCompare: 'Vyberte produkty k porovnání',
    selectAtLeastTwo: 'Vyberte alespoň 2 produkty kliknutím na ikonu vah na kartě produktu',
    productsSelectedForCompare: '{count} z {max} produktů vybráno',
    clearAll: 'Vymazat vše',
    close: 'Zavřít',
    attribute: 'Vlastnost',
    price: 'Cena',
    differs: 'liší se',
    errorLoadingCompare: 'Chyba při načítání porovnání produktů',
    compareHint: 'Zvýrazněné vlastnosti se liší mezi produkty'
  },

  en: {
    // Common
    products: 'products',
    product: 'product',
    brands: 'brands',
    brand: 'brand',
    categories: 'categories',
    category: 'category',
    vendor: 'vendor',
    vendors: 'vendors',
    search: 'Search',
    loading: 'Loading...',
    error: 'Error',

    // Header
    searchPlaceholder: 'Search for products, brands, categories...',

    // Home Page
    heroTitle: 'Compare Prices, Find the Best Deals',
    heroSubtitle: 'Browse thousands of products from trusted vendors. Get the best price guaranteed.',
    popularCategories: 'Popular Categories',
    allProducts: 'All Products',
    productsIn: 'Products in',
    showing: 'Showing',
    loadMoreProducts: 'Load More Products',

    // Product Card
    comparePrices: 'Compare prices',

    // Recently Viewed
    recentlyViewed: 'Recently Viewed',
    clearHistory: 'Clear history',
    clear: 'Clear',

    // Product Page
    backToProducts: 'Back to products',
    priceRange: 'Price Range',
    variants: 'Variants',
    totalOffers: 'Total Offers',
    specifications: 'Specifications',
    availableOffers: 'Available Offers',
    updated: 'Updated',
    viewOffer: 'View Offer',
    errorLoadingProduct: 'Error loading product. Please try again.',
    returnToHome: 'Return to home',
    noOffers: 'No offers available for this product.',
    relatedProducts: 'Related Products',
    productVariants: 'Product Variants',
    quickView: 'Quick View',
    inStock: 'In Stock',
    outOfStock: 'Out of Stock',
    unknown: 'Unknown',
    color: 'Color',
    size: 'Size',
    memory: 'Memory',
    storage: 'Storage',
    material: 'Material',
    nameZA: 'Name (Z-A)',
    mostPopular: 'Most Popular',
    mostVendors: 'Most Vendors',

    // Share
    share: 'Share',
    copyLink: 'Copy link',
    linkCopied: 'Link copied',
    // Cookie Consent
    cookieConsent: 'Cookie Consent',
    acceptAll: 'Accept All',
    decline: 'Decline',

    // Filters
    filters: 'Filters',
    activeFilters: 'Active filters',
    priceRangeLabel: 'Price Range',
    sortBy: 'Sort By',
    nameAZ: 'Name (A-Z)',
    priceLowToHigh: 'Price: Low to High',
    priceHighToLow: 'Price: High to Low',
    newestFirst: 'Newest First',
    clearFilters: 'Clear Filters',
    allCategories: 'All Categories',
    allBrands: 'All Brands',
    minPrice: 'Min price',
    maxPrice: 'Max price',

    // Search Page
    searchResultsFor: 'Search results for:',

    // Brands Page
    browseByBrand: 'Browse by brand',
    allBrands: 'All Brands',
    searchBrands: 'Search brands...',
    found: 'found',

    // Categories Page
    browseByCategory: 'Browse by category',
    allCategories: 'All Categories',
    searchCategories: 'Search categories...',
    noMatchingCategories: 'No categories found matching',
    noMatchingBrands: 'No brands found matching',

    // Product Grid
    errorLoadingProducts: 'Error loading products. Please try again.',

    // Empty States
    noSearchResults: 'No results found',
    noSearchResultsMessage: 'We couldn\'t find any products matching your search',
    noFilteredResults: 'No products match your filters',
    noFilteredResultsMessage: 'Try adjusting or clearing some filters to see more results.',
    noCategoryProducts: 'No products in this category',
    noCategoryProductsMessage: 'We don\'t have products in this category at the moment.',
    noProductsAvailable: 'No products available',
    noProductsAvailableMessage: 'There are no products available at the moment.',
    suggestions: 'Suggestions',
    searchSuggestion1: 'Try different keywords',
    searchSuggestion2: 'Use more general terms',
    searchSuggestion3: 'Check your spelling',
    categorySuggestion1: 'Browse other categories',
    categorySuggestion2: 'Try using search',
    filterSuggestion1: 'Clear some filters',
    filterSuggestion2: 'Expand the price range',
    browseAllCategories: 'Browse all categories',
    backToHome: 'Back to home',

    // Footer
    footerTagline: 'Your premium multi-vendor marketplace. Compare prices and find the best deals from trusted vendors.',
    allRightsReserved: 'All rights reserved',

    // Legal Pages
    privacyPolicy: 'Privacy Policy',
    termsConditions: 'Terms & Conditions',
    cookiePolicy: 'Cookie Policy',
    imprint: 'Legal Notice',
    returnPolicy: 'Returns & Refunds',
    shippingPolicy: 'Shipping & Delivery',
    contact: 'Contact',
    aboutUs: 'About Us',
    legal: 'Legal',
    customerService: 'Customer Service',
    lastUpdated: 'Last updated',

    // 404 Page
    notFoundTitle: 'Page Not Found',
    notFoundMessage: 'The page you are looking for doesn\'t exist or has been moved.',
    searchProducts: 'Search products',

    // Price History
    priceHistory: 'Price History',
    lowestInDays: 'Lowest in {days} days',
    daysRange: '{days} days',
    priceTrendDown: 'Price is down {pct}% since the start of the period',
    priceTrendUp: 'Price is up {pct}% since the start of the period',
    priceTrendStable: 'Price is stable',

    // Compare
    compare: 'Compare',
    compareProducts: 'Compare Products',
    addToCompare: 'Add to compare',
    removeFromCompare: 'Remove from compare',
    compareFull: 'Compare is full (max 4)',
    selectProductsToCompare: 'Select products to compare',
    selectAtLeastTwo: 'Select at least 2 products by clicking the scale icon on product cards',
    productsSelectedForCompare: '{count} of {max} products selected',
    clearAll: 'Clear all',
    close: 'Close',
    attribute: 'Attribute',
    price: 'Price',
    differs: 'differs',
    errorLoadingCompare: 'Error loading product comparison',
    compareHint: 'Highlighted attributes differ between products'
  }
};

// Helper function to get translation
export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations.en[key] || key;
};
